var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c(
        "div",
        { style: _vm.style },
        [
          _c("html-editor", {
            ref: "editor",
            attrs: {
              value: _vm.initialText,
              theme: _vm.themes.bubble,
              "toolbar-module": _vm.toolbarModule,
              "toolbar-defaults": _vm.toolbarDefaults
            },
            on: {
              input: function($event) {
                return _vm.$emit("text-changed", $event)
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }